<template>
  <b-row>
    <b-col cols="12">
      <p>
        <strong>Recipients</strong><br>
        <span class="text-muted">Place every recipient in a new line, separate name and email address with a coma</span>
      </p>
      <b-textarea
        v-model="emailAddressesText"
        placeholder="Mary Doe, mary.joe@reallinks.io\nJohn Doe, john.doe@reallinks.io"
      />
    </b-col>
    <b-col sm="12">
      <b-btn class="mt-3" @click="input" variant="dark">
        Send Test Message
      </b-btn>
    </b-col>
  </b-row>
</template>

<script>
import gql from 'graphql-tag';
import slackifyHtml from 'slackify-html';

const UsersQuery = gql`
  query TestSlackMessageUsers(
    $usersWhere: UserWhereManyInput,
    $getJobs: Boolean = false,
    $jobsWhere: JobWhereManyInput,
    $getContentShares: Boolean = false,
    $contentSharesWhere: ContentShareWhereManyInput
  ) {
    company {
      id
      users(where: $usersWhere) {
        id
        emailAddress
        jobs(where: $jobsWhere) @include(if:$getJobs) {
          id
          title
          excerpt
          shareCode
          linkedInSearchURL
        }
        contentShares(where: $contentSharesWhere) @include(if:$getContentShares)  {
          id
          title
          description
          shareCode
        }
      }
    }
  }
`;

const FromUserQuery = gql`
  query TestSlackFromUser(
    $emailAddress: String,
  ) {
    company {
      id
      users(
        where: {
          NOT: { AND: [ { state: null }, { state: { emailProvider: null } } ] },
          emailAddress: $emailAddress
        }
      ) {
          id
          emailAddress
          fullName
          state {
            emailProvider
          }
      }
    }
  }
`;

const SendTestMessageMutation = gql`
  mutation SentTestMessage($input: String!) {
    sendTestMessage(input: $input)
  }
`;

export default {
  props: {
    body: {
      type: String,
    },
    variables: {
      type: String,
    },
    from: {
      type: String,
    },
    job: {
      type: Object,
    },
    contentShare: {
      type: Object,
    },
    isIndividual: {
      type: Boolean,
    }
  },
  data() {
    return {
      emailAddressesText: null
    };
  },
  apollo: {
    users: {
      query: UsersQuery,
      variables() {
        const { job, contentShare, recipients } = this;
        const usersWhere = {
          OR: recipients.map(({ emailAddress }) => ({ emailAddress }))
        };
        console.log({
          usersWhere,
          getJobs: !!job,
          jobsWhere: job ? { id_in: [ job.id ] } : null,
          getContentShares: !!contentShare,
          contentSharesWhere: contentShare ? { id_in: [ contentShare.id ] } : null
        });
        return {
          usersWhere,
          getJobs: !!job,
          jobsWhere: job ? { id_in: [ job.id ] } : null,
          getContentShares: !!contentShare,
          contentSharesWhere: contentShare ? { id_in: [ contentShare.id ] } : null
        };
      },
      update({ company }) {
        const { users } = company || {};
        return Array.isArray(users) ? users : null;
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      deep: true,
      skip() {
        const { recipients } = this;
        return !Array.isArray(recipients) || !recipients.length;
      }
    },
    fromUser: {
      query: FromUserQuery,
      variables() {
        return { emailAddress: this.from };
      },
      update({ company }) {
        const { users } = company || {};
        return Array.isArray(users) ? users[0] : null;
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      deep: true,
      skip() {
        const { from } = this;
        return !(from || '').includes('@');
      }
    },
  },
  computed: {
    recipients() {
      const { emailAddressesText } = this;
      const lines = (emailAddressesText || '').split('\n')
        .filter(l => l && l.includes(',') && l.includes('@'));
      return lines.map(el => {
        const fullName = el.split(',')[0].trim();
        const emailAddress = el.split(',')[1].trim();
        const firstName = fullName.split(' ')[0].trim();
        const lastName = (fullName.split(' ')[1] || '').trim();
        return {
          emailAddress,
          variables: {
            LEADERBOARD_POSITION: Math.round(Math.random() * 100),
            LEADERBOARD_POINTS: Math.round(Math.random() * 500),
            FIRST_NAME: firstName,
            LAST_NAME: lastName,
            FULL_NAME: fullName,
          }
        };
      });
    }
  },
  methods: {
    async input() {
      const { recipients, users, body, fromUser, job, contentShare } = this;
      const input = {
        messageType: 'SLACK',
        messageDetails: {
          body: slackifyHtml(body),
          from: {
            name: (fromUser || {}).fullName,
            emailAddress: (fromUser || {}).emailAddress,
            accessToken: (fromUser || {}).state.emailProvider.accessToken
          }
        },
        recipients: {
          type: this.isIndividual ? 'INDIVIDUAL' : 'GROUP',
          users: recipients.map(el => {
            const mappedUser = users.find(({ emailAddress }) => emailAddress === el.emailAddress);
            console.log({ mappedUser });
            const mappedJob = Array.isArray((mappedUser || {}).jobs) ? mappedUser.jobs[0] : null;
            const mappedContentShare = Array.isArray((mappedUser || {}).contentShares) ? mappedUser.contentShares[0] : null;
            const { origin } = this.$root;
            const baseURL = origin.includes('localhost') ? 'https://referrals.reallinks.dev' : origin;
            return {
              type: 'INDIVIDUAL',
              emailAddress: el.emailAddress,
              variables: {
                ...el.variables,
                JOB_SHARE_LINK: mappedJob ? `${baseURL}/r/${mappedJob.shareCode}` : null,
                JOB_MATCH_LINK: mappedJob ? mappedJob.linkedInSearchURL : null,
                CONTENT_SHARE_LINK: mappedContentShare ? `${baseURL}/c/${mappedContentShare.shareCode}` : null,
              }
            };
          })
        },
        variables: {
          JOB_TITLE: (job || {}).title,
          JOB_DESCRIPTION: (job || {}).excerpt,
          JOB_SHARE_TEXT: `Work with me as a ${(job || {}).title}`,
          JOB_MATCH_LINK: (job || {}).linkedInSearchURL,
          CONTENT_TITLE: (contentShare || {}).title,
          CONTENT_DESCRIPTION: (contentShare || {}).description,
          CONTENT_SHARE_TEXT: 'We are hiring. Apply to one of our openings!',
          LEADERBOARD_FIRST_POINTS: 1356,
          LEADERBOARD_SECOND_POINTS: 1110,
          LEADERBOARD_THIRD_POINTS: 936,
          LEADERBOARD_FIRST_NAME: 'David Ohayon',
          LEADERBOARD_SECOND_NAME: 'Barney Mellors',
          LEADERBOARD_THIRD_NAME: 'Sarah Jane',
          LEADERBOARD_FIRST_PRIZE_TITLE: '£1000 Amazon Voucher',
          LEADERBOARD_SECOND_PRIZE_TITLE: '£500 Amazon Voucher',
          LEADERBOARD_THIRD_PRIZE_TITLE: '£200 Amazon Voucher'
        }
      };
      console.log({ input });
      try {
        await this.$apollo.mutate({
          mutation: SendTestMessageMutation,
          variables: { input: JSON.stringify(input) },
        });
      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/test-message-form.vue